import { render, staticRenderFns } from "./StagingProfile.vue?vue&type=template&id=525bb2f6&scoped=true&"
import script from "./StagingProfile.vue?vue&type=script&lang=js&"
export * from "./StagingProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525bb2f6",
  null
  
)

export default component.exports